import { render } from "./SignerPanelComponent.vue?vue&type=template&id=c1afbd56&scoped=true"
import script from "./SignerPanelComponent.vue?vue&type=script&lang=js"
export * from "./SignerPanelComponent.vue?vue&type=script&lang=js"

import "./SignerPanelComponent.vue?vue&type=style&index=0&id=c1afbd56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1afbd56"]])

export default __exports__